import React from 'react';
import { useApplicationState } from '@atlas/core';

import ProfileUpdateForm from 'components/ClientProfile/Profile/ProfileUpdateForm';
import { HeaderTitle } from '@atlas/ui';
import SeoPageText from 'components/SeoPage/SeoPageText';

const ProfileMain = () => {
  const { account } = useApplicationState();

  return (
    <>
      <div className="title-wrapper">
        <HeaderTitle title="account_profile_title" className="sub-text block-medium border" />
      </div>

      <ProfileUpdateForm account={account} />
      <SeoPageText />
    </>
  );
};

export default ProfileMain;
